import { Group, Input, InputWrapperProps, Stack } from '@mantine/core';
import React from 'react';
import { GAP_BETWEEN_COLUMNS, LEFT_COLUMN_WIDTH } from '../constants/sizes';

export function MantineInputWrapper({ label, id, required, description, error, children }: InputWrapperProps) {
  return (
    <Group gap={0} id={id} my='xs'>
      <Stack
        miw={`${LEFT_COLUMN_WIDTH}%`}
        style={{ alignSelf: 'start' }}
        gap={0}
        mr={GAP_BETWEEN_COLUMNS}
        flex={LEFT_COLUMN_WIDTH}
      >
        <Input.Label required={required}>{label}</Input.Label>
        <Input.Description>{description}</Input.Description>
      </Stack>
      <Stack m={0} gap={0} flex={100 - LEFT_COLUMN_WIDTH}>
        {children}
        <Input.Error>{error}</Input.Error>
      </Stack>
    </Group>
  );
}
